import { Injectable } from '@angular/core';
import { TranslatableProperty } from '../language/models/translatable-property.model';
import { LanguageService } from '../language/services/language.service';

/**
 * This service creates slugs.
 *
 * @export
 * @class SlugService
 */
@Injectable()
export class SlugService {
  constructor(private readonly languageService: LanguageService) {}

  /**
   * Creates slug from a translatable property, according to the currentLang.
   *
   * @param {TranslatableProperty} name
   * @returns
   * @memberof SlugService
   */
  public slugifyTranslatableProperty(name: TranslatableProperty) {
    return this.slugify(name.get(this.languageService.currentLang));
  }

  /**
   * Slugify one input.
   *
   * @param {*} input
   * @returns
   * @memberof SlugService
   */
  public slugify(input): string {
    if (!input) {
      return;
    }
    let tmp = input;

    const from = 'Ã£Ã Ã¡Ã¤Ã¢áº½Ã¨Ã©Ã«ÃªÃ¬Ã­Ã¯Ã®ÃµÃ²Ã³Ã¶Ã´Ã¹ÃºÃ¼Ã»Ã±Ã§Â·/_,:;';
    const to = 'aaaaaeeeeeiiiiooooouuuunc------';

    for (let i = 0, len = from.length; i < len; i = i + 1) {
      tmp = tmp.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    return tmp
      .toString() // Cast to string
      .toLowerCase() // Convert the string to lowercase letters
      .trim() // Remove whitespace from both sides of a string
      .replace(/\s+/g, '-') // Replace spaces with -
      .replace(/&/g, '-y-') // Replace & with 'and'
      .replace(/[^\w\-]+/g, '') // Remove all non-word chars
      .replace(/\-\-+/g, '-'); // Replace multiple - with single -
  }
}
